import React from 'react';
import { AlertTriangle, CheckCircle, FileText } from 'lucide-react';

export const Terms: React.FC = () => {
  return (
    <div className="pt-20">
      {/* Header */}
      <div className="bg-secondary text-white py-16 px-6 relative overflow-hidden">
        <div className="container mx-auto relative z-10">
            <p className="text-blue-400 font-bold tracking-wider uppercase text-xs mb-2">Legal</p>
            <h1 className="text-3xl md:text-5xl font-bold mb-4">Terms of Service</h1>
            <p className="text-gray-400 max-w-2xl">
              Last Updated: September 15, 2025
            </p>
        </div>
      </div>

      <div className="bg-white py-20 px-6">
        <div className="container mx-auto max-w-4xl">
          
          {/* Critical Disclaimer */}
          <div className="bg-red-50 border border-red-100 rounded-2xl p-6 mb-12 flex items-start gap-4">
             <div className="bg-red-100 text-red-600 p-2 rounded-lg flex-shrink-0">
                 <AlertTriangle size={24} />
             </div>
             <div>
                 <h3 className="text-red-800 font-bold text-lg mb-1">Medical Emergency Disclaimer</h3>
                 <p className="text-red-700 text-sm leading-relaxed">
                     This app is NOT for medical emergencies. If you are experiencing a medical emergency, chest pain, difficulty breathing, or severe injury, please call your local emergency services or visit the nearest hospital immediately.
                 </p>
             </div>
          </div>

          {/* Content */}
          <div className="space-y-12 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">1. Acceptance of Terms</h2>
              <p>
                By downloading, accessing, or using the Men's Health Clinic Africa mobile application or website, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">2. Description of Services</h2>
              <p>
                MHC Africa provides a digital platform connecting users with independent healthcare providers ("Specialists") for telemedicine consultations. We also facilitate the ordering of prescriptions and lab tests.
              </p>
              <p className="mt-4">
                  <strong>Note:</strong> MHC Africa does not practice medicine. The medical advice provided is solely from the Specialists you consult with.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">3. User Accounts</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You must be at least 18 years old to create an account.</li>
                <li>You maintain the confidentiality of your login credentials.</li>
                <li>You agree to provide accurate, current, and complete health information.</li>
                <li>We reserve the right to suspend accounts that violate these terms.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">4. Payment and Refunds</h2>
              <p className="mb-4">
                  Consultation fees are payable at the time of booking. Prices for services are clearly displayed in the app.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Cancellations:</strong> You may cancel up to 4 hours before your appointment for a full refund.</li>
                <li><strong>No-Shows:</strong> Failure to attend a scheduled appointment without notice may result in a forfeiture of the fee.</li>
                <li><strong>Refunds:</strong> Refund requests for technical issues will be reviewed on a case-by-case basis.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">5. Intellectual Property</h2>
              <p>
                The App and its original content, features, and functionality are owned by Men's Health Clinic Africa and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">6. Limitation of Liability</h2>
              <p>
                In no event shall Men's Health Clinic Africa, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
              </p>
            </section>

             <section>
              <h2 className="text-2xl font-bold text-secondary mb-4">7. Contact Information</h2>
              <p>
                For questions regarding these Terms of Service, please contact us at:
              </p>
              <div className="mt-4 bg-gray-50 p-6 rounded-xl inline-block">
                <p className="font-bold text-secondary">Men's Health Clinic Africa</p>
                <p>281a Herbert Chitepo Avenue</p>
                <p>Harare</p>
                <p className="mt-2 text-primary font-medium">support@menshealthclinic.africa</p>
                <p className="text-gray-500 text-sm mt-1">+263 776 621 188</p>
              </div>
            </section>
          </div>

        </div>
      </div>
    </div>
  );
};